import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';

import { nameChanged } from 'actions/myself';
import { purchaseItem } from 'actions/fate';
import Modal from 'components/Modal';

import ChangeNameForm from './ChangeNameForm';
import { IAppState } from 'types/app';

interface State {
  message?: any,
  purchaseComplete: boolean,
}

const INITIAL_STATE = {
  message: undefined,
  purchaseComplete: false,
};

export class ChangeNameModal extends Component<Props, State> {
  state = { ...INITIAL_STATE };

  handleRequestClose = () => {
    const { onRequestClose } = this.props;
    this.setState({ ...INITIAL_STATE });
    onRequestClose();
  };

  handleSubmit = async ({ name }: { name: string }, { setSubmitting }: { setSubmitting: (_: boolean) => void }) => {
    const {
      dispatch,
      fateData: { id },
    } = this.props;
    const data = await dispatch(purchaseItem({ storeItemId: id, newName: name }));
    setSubmitting(false);
    if (data.isSuccess) {
      const { characterName, message } = data;
      this.setState({ message, purchaseComplete: true });
      // Dispatch an action so that reducers will update
      dispatch(nameChanged(characterName));
    }
  };

  renderContent = () => {
    const { cost, currentFate, onRequestClose } = this.props;
    const { message, purchaseComplete } = this.state;
    if (purchaseComplete) {
      return (
        <div>
          {message}
        </div>
      );
    }
    if (currentFate < cost) {
      return (
        <div style={{ alignItems: 'center', display: 'flex', justifyContent: 'space-between' }}>
          <span>
            {`Changing your name costs ${cost} Fate; you have ${currentFate}.`}
          </span>
          <Link onClick={onRequestClose} className="button button--secondary" to="/fate">
            Buy Fate
          </Link>
        </div>
      );
    }

    return (
      <ChangeNameForm
        cost={cost}
        onSubmit={this.handleSubmit}
      />
    );
  };

  render = () => {
    const { isOpen } = this.props;
    const { purchaseComplete, message } = this.state;

    return (
      <Modal
        isOpen={isOpen}
        onRequestClose={this.handleRequestClose}
      >
        <div>
          <h3 className="heading heading--2 heading--inverse">
            {purchaseComplete && message ? 'Success!' : 'Change your name'}
          </h3>
          {this.renderContent()}
        </div>
      </Modal>
    );
  };
}

interface Props extends RouteComponentProps {
  cost: number,
  currentFate: number,
  dispatch: Function,
  fateData: { id: number },
  isOpen: boolean,
  onRequestClose: () => void,
}

const mapStateToProps = ({
  fate: { data: { currentFate, fateCards } },
}: IAppState) => ({
  currentFate,
  cost: fateCards.find(({ action }) => action === 'AskNameChange')?.price ?? 0,
  fateData: fateCards.find(({ action }) => action === 'AskNameChange')!,
});

export default withRouter(connect(mapStateToProps)(ChangeNameModal));